import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 bg-[#80A7E6]" data-id="element-89">
      <div className="container mx-auto px-4" data-id="element-90">
        <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-6 text-center md:text-left bg-green-50 p-6 md:p-8 rounded-2xl border-2 border-green-200" data-id="element-91">
          <div className="shrink-0" data-id="element-92">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center" data-id="element-93">
              <ShieldCheck size={36} className="text-green-600" data-id="element-94" />
            </div>
          </div>
          <div data-id="element-95">
            <h2 className="text-xl md:text-2xl font-black text-black uppercase mb-2" data-id="element-96">
              🛡️ Garantía 7 días — Sin preguntas
            </h2>
            <p className="text-sm text-slate-600" data-id="element-97">
              Descargás los tomos. Los usás una semana. Si en 7 días no es lo
              que esperabas: devolución del 100%. Sin vueltas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}